// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var StatusType;
(function (StatusType) {
    StatusType["LEGACY"] = "LEGACY";
    StatusType["INVITED"] = "INVITED";
    StatusType["ACTIVE"] = "ACTIVE";
    StatusType["DISABLED"] = "DISABLED";
})(StatusType || (StatusType = {}));
export var StatusType_index;
(function (StatusType_index) {
    StatusType_index[StatusType_index["LEGACY"] = 0] = "LEGACY";
    StatusType_index[StatusType_index["INVITED"] = 1] = "INVITED";
    StatusType_index[StatusType_index["ACTIVE"] = 2] = "ACTIVE";
    StatusType_index[StatusType_index["DISABLED"] = 3] = "DISABLED";
})(StatusType_index || (StatusType_index = {}));
export var UserType;
(function (UserType) {
    UserType["UNKNOWN"] = "UNKNOWN";
    UserType["PRACTICE"] = "PRACTICE";
    UserType["WEAVE"] = "WEAVE";
})(UserType || (UserType = {}));
export var UserType_index;
(function (UserType_index) {
    UserType_index[UserType_index["UNKNOWN"] = 0] = "UNKNOWN";
    UserType_index[UserType_index["PRACTICE"] = 1] = "PRACTICE";
    UserType_index[UserType_index["WEAVE"] = 2] = "WEAVE";
})(UserType_index || (UserType_index = {}));
export var AuthMethod;
(function (AuthMethod) {
    AuthMethod["DEFAULT"] = "DEFAULT";
    AuthMethod["EMAIL"] = "EMAIL";
    AuthMethod["PHONE"] = "PHONE";
})(AuthMethod || (AuthMethod = {}));
export var AuthMethod_index;
(function (AuthMethod_index) {
    AuthMethod_index[AuthMethod_index["DEFAULT"] = 0] = "DEFAULT";
    AuthMethod_index[AuthMethod_index["EMAIL"] = 1] = "EMAIL";
    AuthMethod_index[AuthMethod_index["PHONE"] = 2] = "PHONE";
})(AuthMethod_index || (AuthMethod_index = {}));
export var MFAMethodState;
(function (MFAMethodState) {
    MFAMethodState["NOT_VALIDATED"] = "NOT_VALIDATED";
    MFAMethodState["PRIMARY"] = "PRIMARY";
    MFAMethodState["VALIDATED"] = "VALIDATED";
})(MFAMethodState || (MFAMethodState = {}));
export var MFAMethodState_index;
(function (MFAMethodState_index) {
    MFAMethodState_index[MFAMethodState_index["NOT_VALIDATED"] = 0] = "NOT_VALIDATED";
    MFAMethodState_index[MFAMethodState_index["PRIMARY"] = 1] = "PRIMARY";
    MFAMethodState_index[MFAMethodState_index["VALIDATED"] = 2] = "VALIDATED";
})(MFAMethodState_index || (MFAMethodState_index = {}));
export const AuthService = {
    InitiateAuth(fn, req) {
        return fn(`/auth-api/v3/auth/initiate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    VerifyAuth(fn, req) {
        return fn(`/auth-api/v3/auth/verify`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    BeginWebAuthnRegistration(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/begin-registration`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Register(fn, req) {
        return fn(`/auth-api/v3/auth/register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CompleteWebAuthnRegistration(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/complete-registration`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Deregister(fn, req) {
        return fn(`/auth-api/v3/auth/deregister`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    BeginWebAuthnLogin(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/begin-login`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CompleteWebAuthnLogin(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/complete-login`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListWebAuthnCreds(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteWebAuthnCred(fn, req) {
        return fn(`/auth-api/v3/auth/webauthn/delete?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    EnableMFA(fn, req) {
        return fn(`/auth-api/v3/mfa/enable`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DisableMFA(fn, req) {
        return fn(`/auth-api/v3/mfa/disable`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    IsPasswordPwned(fn, req) {
        return fn(`/auth-api/v3/password/pwned`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListAuth(fn, req) {
        return fn(`/auth-api/v3/auth/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ApiLogin(fn, req) {
        return fn(`/auth-api/v3/token/login`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SignSessionToken(fn, req) {
        return fn(`/auth-api/v3/token/session/sign`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetRoleUsers(fn, req) {
        return fn(`/auth-api/v3/users/roles?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetRoles(fn, req) {
        return fn(`/auth-api/v3/roles?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateRole(fn, req) {
        return fn(`/auth-api/v3/roles`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateRole(fn, req) {
        return fn(`/auth-api/v3/roles`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteRole(fn, req) {
        return fn(`/auth-api/v3/roles?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    ExchangeToken(fn, req) {
        return fn(`/auth-api/v3/exchangetoken`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UnlockAccount(fn, req) {
        return fn(`/auth-api/v3/unlock`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Internal to Okta Role Management
     */
    GetInternalRoles(fn, req) {
        return fn(`/auth-api/v3/roles/it?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateInternalRoleMapping(fn, req) {
        return fn(`/auth-api/v3/roles/it`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteInternalRoleMapping(fn, req) {
        return fn(`/auth-api/v3/roles/it?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    GetInternalRoleMapping(fn, req) {
        return fn(`/auth-api/v3/roles/it/map?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    FHIRAuthToken(fn, req) {
        return fn(`/auth-api/v3/token/fhir`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetUserRolesForAllLocations(fn, req) {
        return fn(`/auth-api/v3/users/roles/all?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetRoleCategoriesByType(fn, req) {
        return fn(`/auth-api/v3/roles/categories?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetUserProfile(fn, req) {
        return fn(`/auth-api/v3/users/profile?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateUserProfile(fn, req) {
        return fn(`/auth-api/v3/users/profile`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetUserDetails(fn, req) {
        return fn(`/auth-api/v3/users/details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetUsersInLocations(fn, req) {
        return fn(`/auth-api/v3/users/locations`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetPrimaryContact(fn, req) {
        return fn(`/auth-api/v3/contact/primary?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetContacts(fn, req) {
        return fn(`/auth-api/v3/contacts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AddContact(fn, req) {
        return fn(`/auth-api/v3/contact`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteContact(fn, req) {
        return fn(`/auth-api/v3/contact?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    ValidateContact(fn, req) {
        return fn(`/auth-api/v3/contact/validate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    MakeContactPrimary(fn, req) {
        return fn(`/auth-api/v3/contact/primary`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ResendContactValidation(fn, req) {
        return fn(`/auth-api/v3/contact/resend`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This endpoint allows the security team to reset a user's password
     * and invalidate any existing sessions
     * only a single parameter needs to be passed in the body
     * user_id: list of user_id to reset
     * jti: list user jti to reset and invalidate
     * username: list of username reset
     */
    ResetUser(fn, req) {
        return fn(`/auth-api/v3/users/reset`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RefreshToken will take the Authorization header and return a new token and jti_token if possible
     */
    RefreshToken(fn, req) {
        return fn(`/auth-api/v3/auth/refresh?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSsoSettings(fn, req) {
        return fn(`/auth-api/v3/sso/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSsoSettings(fn, req) {
        return fn(`/auth-api/v3/sso/settings`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSsoSettings(fn, req) {
        return fn(`/auth-api/v3/sso/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    CreateSsoSettings(fn, req) {
        return fn(`/auth-api/v3/sso/settings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSsoMapping(fn, req) {
        return fn(`/auth-api/v3/sso/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateSsoMapping(fn, req) {
        return fn(`/auth-api/v3/sso/mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateSsoMapping(fn, req) {
        return fn(`/auth-api/v3/sso/mapping`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSsoMapping(fn, req) {
        return fn(`/auth-api/v3/sso/mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    GetSsoConnection(fn, req) {
        return fn(`/auth-api/v3/sso/connection?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSsoConnection(fn, _req) {
        return fn(`/auth-api/v3/sso/connection`, { method: "PATCH" });
    },
    /**
     *supports deleting a weave TAS user
     *supports deleting self or deleting as a weave user with USER_WRITE permission
     */
    DeleteUser(fn, req) {
        try {
            fm.validateUrlParam(req["username"], "username");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/auth-api/v3/users/delete/${req["username"]}?${fm.renderURLSearchParams(req, ["username"])}`, { method: "DELETE" });
    },
    /**
     * SCIM v2
     */
    GetScimConnections(fn, req) {
        return fn(`/auth-api/v3/scim/connection?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateScimConnection(fn, req) {
        return fn(`/auth-api/v3/scim/connection`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteScimConnection(fn, req) {
        return fn(`/auth-api/v3/scim/connection?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    CreateScimConnection(fn, req) {
        return fn(`/auth-api/v3/scim/connection`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
